import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  InputNumber,
  message,
  Modal,
  PageHeader,
  Switch,
  Table,
} from "antd";
import { LanguageContext } from "../../context/LanguageContext";
import { superAdminService } from "../../_services/superadmin.service";

class DemoCctnsCity extends Component {
  static contextType = LanguageContext;
  state = {
    data: [],
    loading: false,
    searchText: "",
    addModalVisible: false,
    addLoading: false,
    selectedRecord: null,
    selectedCityId: undefined,
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
    },
  };

  hasCityId = (record) =>
    record?.city_id !== null &&
    record?.city_id !== undefined &&
    record?.city_id !== "";

  CctnsCityList = () => {
    this.setState({ loading: true });
    superAdminService
      .CctnsCityList()
      .then((res) => {
        this.setState({
          data: res.results || [],
          loading: false,
        });
      })
      .catch(() => {
        message.error("Failed to load CCTNS districts");
        this.setState({ loading: false });
      });
  };
  componentDidMount = () => {
    this.CctnsCityList();
  };

  CctnsCityMap = (record, cityId) => {
    const mappedCityId = cityId || record.city_id;
    const payload = {
      is_map: true,
      city_name: record.city_name || record.district,
      cityId: mappedCityId,
    };
    return superAdminService
      .CctnsCityMap(payload)
      .then(() => {
        message.success("Updated Successfully");
        this.setState((prevState) => ({
          data: prevState.data.map((item) =>
            item.district === record.district
              ? {
                  ...item,
                  is_map: true,
                  city_id: mappedCityId,
                  city_name: record.city_name || record.district,
                }
              : item,
          ),
        }));
      })
      .catch((error) => {
        message.error("Update failed");
        throw error;
      });
  };

  handleStatusToggle = (record) => {
    if (record.is_map || !this.hasCityId(record)) {
      return;
    }
    this.CctnsCityMap(record);
  };

  openAddCityModal = (record) => {
    this.setState({
      addModalVisible: true,
      selectedRecord: record,
      selectedCityId: undefined,
    });
  };

  closeAddCityModal = () => {
    this.setState({
      addModalVisible: false,
      addLoading: false,
      selectedRecord: null,
      selectedCityId: undefined,
    });
  };

  handleAddCityId = () => {
    const { selectedRecord, selectedCityId } = this.state;
    if (!selectedCityId) {
      message.warning("Please enter a city ID");
      return;
    }

    this.setState({ addLoading: true });
    this.CctnsCityMap(selectedRecord, selectedCityId)
      .then(() => {
        this.closeAddCityModal();
      })
      .finally(() => {
        this.setState({ addLoading: false });
      });
  };

  handleTableChange = (pagination) => {
    this.setState((prevState) => ({
      pagination: {
        ...prevState.pagination,
        ...pagination,
      },
    }));
  };
  getFilteredData = () => {
    const { data, searchText } = this.state;
    const query = searchText.trim().toLowerCase();

    if (!query) {
      return data;
    }

    return data.filter((item) => {
      const stateName = (item.state || "").toLowerCase();
      const statusText = item.is_active ? "active" : "inactive";
      return stateName.includes(query) || statusText.includes(query);
    });
  };

  render() {
    const {
      loading,
      pagination,
      data,
      addModalVisible,
      addLoading,
      selectedRecord,
      selectedCityId,
    } = this.state;
    const { t } = this.context;
    const filteredData = this.getFilteredData();

    const columns = [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
        render: (_, __, rowIndex) =>
          (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
      },
      {
        title: "City Name",
        dataIndex: "district",
        key: "district",
      },
      {
        title: "City Id",
        dataIndex: "city_id",
        key: "city_id",
        render: (cityId) => cityId || "-",
      },
      {
        title: "Status",
        dataIndex: "is_map",
        key: "is_map",
        render: (is_active) => (is_active ? "Mapped" : "Not Mapped"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        render: (text, record) =>
          this.hasCityId(record) ? (
            <Switch
              checked={!!record.is_map}
              checkedChildren="Mapped"
              unCheckedChildren="Not Mapped"
              onChange={() => this.handleStatusToggle(record)}
            />
          ) : (
            <Button
              type="primary"
              size="small"
              onClick={() => this.openAddCityModal(record)}
            >
              Add City ID
            </Button>
          ),
      },
    ];
    return (
      <>
        <div
          className="site-page-header-ghost-wrapper"
          style={{
            padding: "20px",
            background: "#fff",
            marginBottom: "20px",
          }}
        >
          <PageHeader title="CCTNS City Map" />
          <Table
            bordered
            loading={loading}
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={filteredData}
            rowKey={(record) =>
              `${record.district}-${record.city_id ?? "unmapped"}`
            }
            rowClassName={() => "govt-table-row"}
            pagination={{
              ...pagination,
              total: data.length,
              showTotal: (total) => `Total ${total} states`,
            }}
            onChange={this.handleTableChange}
          />
          <Modal
            title={`Add City ID${
              selectedRecord?.district ? ` for ${selectedRecord.district}` : ""
            }`}
            visible={addModalVisible}
            onOk={this.handleAddCityId}
            onCancel={this.closeAddCityModal}
            confirmLoading={addLoading}
            okText="Add"
          >
            <InputNumber
              min={1}
              placeholder="Enter City ID"
              style={{ width: "100%" }}
              value={selectedCityId}
              onChange={(value) => this.setState({ selectedCityId: value })}
            />
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedCctnsCity = connect(mapStateToProps)(DemoCctnsCity);
export { connectedCctnsCity as CctnsCity };
